import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-energietransitie',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconEnergietransitie {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M16.39 24.04h-.2c-.68 0-1.16-.67-.95-1.31l1.56-4.67h-1.52a.998.998 0 0 1-.97-1.24l1.5-5.98c.11-.44.51-.75.97-.75h2.26c.74 0 1.23.78.89 1.44l-1.78 3.54h2.14c.76 0 1.25.82.87 1.48l-3.91 6.97c-.18.32-.51.51-.87.51Zm14.86-9.35-2.96 2.95a.984.984 0 0 0 0 1.4h.01c.39.4 1.01.4 1.4.01l1.32-1.31c-.38 6.83-6.07 12.27-13.02 12.27-3.52 0-6.86-1.4-9.3-3.88-.37-.38-.97-.43-1.37-.09h-.01c-.44.39-.46 1.06-.05 1.47C10.09 30.37 13.95 32 18.01 32c8.01 0 14.56-6.27 15.01-14.13l1.28 1.27c.39.39 1.01.39 1.4 0h.01c.39-.4.39-1.02 0-1.41l-3.05-3.04a.984.984 0 0 0-1.4 0Zm-23.54.27a.996.996 0 0 0-1.41 0l-1.31 1.31C5.37 9.44 11.06 4 18.01 4c3.52 0 6.86 1.4 9.3 3.88.37.38.97.43 1.37.09h.01c.44-.39.46-1.06.05-1.47A15.076 15.076 0 0 0 18 2.01c-8.01 0-14.56 6.27-15.01 14.13L1.7 14.86a.996.996 0 1 0-1.41 1.41l3.06 3.04c.39.39 1.02.39 1.41 0l2.95-2.94a.996.996 0 0 0 0-1.41"/>
</svg>

    );
  }
}
